import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationResults } from 'src/app/models/notifications';
import { PlanogramStatusType } from 'src/app/models/planogram-status';
import { FolderApiService } from 'src/app/services/folder-api.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { PlanogramApiService } from 'src/app/services/planogram-api.service';
import { PlanogramService } from 'src/app/services/planogram.service';
import { NgIf, NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-notifications-page',
    templateUrl: './notifications.component.html',
    styleUrl: './notifications.component.scss',
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, NgFor, DatePipe]
})
export class NotificationsPageComponent implements OnInit {
  notificationsResults: NotificationResults | null = null;
  loading = true;

  constructor(
    private notificationsService: NotificationsService,
    private folderApi: FolderApiService,
    private planogramApiService: PlanogramApiService,
    private planogramService: PlanogramService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadNotifications(1);
  }

  loadNotifications(page: number) {
    this.loading = true;
    this.notificationsService.getNotifications(page, 20, false).subscribe((res) => {
      this.notificationsResults = res;
      this.loading = false;
    });
  }

  async notificationClicked(id: string) {
    this.notificationsService.markAsSeen(id).subscribe(async (success) => {
      if (success && this.notificationsResults) {
        const item = this.notificationsResults.notifications.find(n => n.id === id);
        if (item) item.isSeen = true;

        try {
          const planogram = await this.folderApi.getNotificationPlanogram(id).toPromise();
          if (planogram) {
            if (planogram && planogram.states.length > 0) {
              const latestState = [...planogram.states].sort((a, b) => 
                new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime()
              )[0];
              this.router.navigate([`/planogram/${planogram.guid}/${latestState.guid}`]);
            }
          }
        } catch (err) {
          console.error('Failed to open linked planogram', err);
        }
      }
    });
  }

  nextPage() {
    if (!this.notificationsResults) return;
    const next = this.notificationsResults.currentPage + 1;
    if (next <= this.notificationsResults.totalPages) {
      this.loadNotifications(next);
    }
  }

  prevPage() {
    if (!this.notificationsResults) return;
    const prev = this.notificationsResults.currentPage - 1;
    if (prev > 0) {
      this.loadNotifications(prev);
    }
  }
}